// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-family-roboto {
  font-family: "Roboto", "sans-serif", "Montserrat" !important;
}

.font-family-montserrat {
  font-family: "Montserrat", "Roboto", "sans-serif" !important;
}

.primary-heading {
  font-size: 32px !important;
}

.secondary-heading {
  font-size: 24px !important;
}

.tertiary-heading {
  font-size: 28px !important;
}

.super-heading {
  font-size: 48px !important;
}

.super-heading-42 {
  font-size: 42px !important;
}

.sub-heading {
  font-size: 18px !important;
}

.heading-22 {
  font-size: 22px !important;
}

.primary-title {
  font-size: 16px !important;
}

.secondary-title {
  font-size: 14px !important;
}

.tertiary-title {
  font-size: 12px !important;
}

.title-10 {
  font-size: 10px !important;
}

.font-weight-400 {
  font-weight: 400 !important;
}

.font-weight-500 {
  font-weight: 500 !important;
}

.font-weight-600 {
  font-weight: 600 !important;
}

.font-weight-700 {
  font-weight: 700 !important;
}

.font-weight-900 {
  font-weight: 900 !important;
}

.mid-gray {
  color: #676c70;
}

.primary-color {
  color: #ff611d !important;
}

.bg-primary-color {
  background-color: #ff611d !important;
}

.bg-solitude-color {
  background-color: #E9EFFD !important;
}

.secondary-color {
  color: #333333 !important;
}

.bg-white-color {
  background-color: #ffffff !important;
}

.bg-black {
  background-color: #000000 !important;
}

.white-color {
  color: #ffffff !important;
}

.black-color {
  color: #000000 !important;
}

.error-color {
  color: #dc3545 !important;
}

.success-color {
  color: #165c27 !important;
}

.grey-color {
  color: #747070 !important;
}

.selected-field-color {
  color: #6c757d;
}

.dark-gray-color {
  color: #3c3c3c !important;
}

.orange-yellowish-color {
  color: #ffa412 !important;
}

.orange-color-300 {
  color: #FFA300 !important;
}

.orange-yellowish-bg-color {
  background-color: #ffa412 !important;
}

.primary-bg-color {
  background-color: #ff611d !important;
}

.secondary-bg-color {
  background-color: #333333 !important;
}

.orange-color-bg-300 {
  background-color: #FFA300 !important;
}

.bg-none {
  background-color: transparent;
}

.green-bg-color {
  background-color: #40d698 !important;
}

.light-gray-bg-color {
  background-color: #9d99b9 !important;
}

.bg-card-white {
  background-color: #ffffff !important;
  border-radius: 10px !important;
  box-shadow: -2px 4px 15px rgba(131, 164, 249, 0.25) !important;
}

.box-shadow-global {
  box-shadow: -2px 4px 15px rgba(131, 164, 249, 0.25) !important;
}

.border-radius-20-left {
  border-radius: 20px 0px 0px 20px !important;
}

.border-radius-20-right {
  border-radius: 0px 20px 20px 0px !important;
}

.border-radius-50-left {
  border-radius: 50px 0px 0px 50px !important;
}

.border-radius-50-right {
  border-radius: 0px 50px 50px 0px !important;
}

.border-radius-20-top {
  border-radius: 20px 20px 0px 0px !important;
}

.border-radius-10 {
  border-radius: 10px !important;
}

.border-radius-5 {
  border-radius: 5px !important;
}

.border-radius-15 {
  border-radius: 15px !important;
}

.border-radius-20 {
  border-radius: 20px !important;
}

.border-radius-rounded {
  border-radius: 50%;
}

.border-dashed {
  border: 1px dashed #c4c4c4 !important;
}

.border-black {
  border: 1px solid #000000 !important;
}

.border-gray {
  border: 1px solid #c4c4c4 !important;
}

.border-primary-active {
  border: 1px solid #ff611d !important;
}

.border-dashed-white {
  border: 1px dashed #fff !important;
}

.border-none {
  border: none !important;
}

.border-error {
  border: 1px solid #d32f2f !important;
}

.border-success {
  border: 1px solid #165c27 !important;
}

.border-warning {
  border: 1px solid #ffa412 !important;
}

.guest-rating-box-shadow {
  box-shadow: 1px 1px 8px 0px #ecf2fe;
}

.center-text {
  text-align: center !important;
}

.flex {
  display: flex !important;
}

.justify-center {
  justify-content: center !important;
}

.justify-space-between {
  justify-content: space-between !important;
}

.justify-space-around {
  justify-content: space-around !important;
}

.justify-end {
  justify-content: flex-end !important;
}

.align-center {
  align-items: center !important;
}

.align-space-between {
  align-items: space-between !important;
}

.align-end {
  align-items: flex-end !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-grow {
  flex-grow: 1 !important;
}

.text-decoration {
  text-decoration: none !important;
  color: unset !important;
}

a {
  text-decoration: none;
  color: inherit;
}

.text-transform {
  text-transform: capitalize;
}

.height-40 {
  height: 40px;
}

.width-40 {
  width: 40px;
}

::-webkit-scrollbar {
  width: 3px;
  background-color: #F5F5F5;
  border-radius: 10px;
  height: 4px;
  cursor: pointer;
}

::-webkit-scrollbar-thumb {
  background-color: #ff611d;
  border-radius: 10px;
  cursor: pointer;
}

.hover:hover {
  background-color: rgba(255, 97, 29, 0.2) !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/common.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAIA;EACE,4DAAA;AADF;;AAIA;EACE,4DAAA;AADF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAOA;EACE,0BAAA;AAJF;;AAOA;EACE,0BAAA;AAJF;;AAOA;EACE,0BAAA;AAJF;;AAOA;EACE,0BAAA;AAJF;;AASA;EACE,2BAAA;AANF;;AASA;EACE,2BAAA;AANF;;AASA;EACE,2BAAA;AANF;;AASA;EACE,2BAAA;AANF;;AASA;EACE,2BAAA;AANF;;AAUA;EACE,cC9CS;ADuCX;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,oCAAA;AAPF;;AAUA;EACE,oCAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,oCAAA;AAPF;;AAUA;EACE,oCAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,cCnGqB;AD4FvB;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAYA;EACE,oCAAA;AATF;;AAYA;EACE,oCAAA;AATF;;AAYA;EACE,oCAAA;AATF;;AAYA;EACE,oCAAA;AATF;;AAYA;EACE,6BAAA;AATF;;AAYA;EACE,oCAAA;AATF;;AAYA;EACE,oCAAA;AATF;;AAYA;EACE,oCAAA;EACA,8BAAA;EACA,8DAAA;AATF;;AAYA;EACE,8DAAA;AATF;;AAaA;EACE,2CAAA;AAVF;;AAaA;EACE,2CAAA;AAVF;;AAaA;EACE,2CAAA;AAVF;;AAaA;EACE,2CAAA;AAVF;;AAcA;EACE,2CAAA;AAXF;;AAcA;EACE,8BAAA;AAXF;;AAcA;EACE,6BAAA;AAXF;;AAcA;EACE,8BAAA;AAXF;;AAcA;EACE,8BAAA;AAXF;;AAcA;EACE,kBCnKqB;ADwJvB;;AAcA;EACE,qCAAA;AAXF;;AAcA;EACE,oCAAA;AAXF;;AAcA;EACE,oCAAA;AAXF;;AAcA;EACE,oCAAA;AAXF;;AAcA;EACE,kCAAA;AAXF;;AAcA;EACE,uBAAA;AAXF;;AAcA;EACE,oCAAA;AAXF;;AAcA;EACE,oCAAA;AAXF;;AAcA;EACE,oCAAA;AAXF;;AAgBA;EACE,mCAAA;AAbF;;AAgBA;EACE,6BAAA;AAbF;;AAgBA;EACE,wBAAA;AAbF;;AAgBA;EACE,kCAAA;AAbF;;AAgBA;EACE,yCAAA;AAbF;;AAgBA;EACE,wCAAA;AAbF;;AAgBA;EACE,oCAAA;AAbF;;AAgBA;EACE,8BAAA;AAbF;;AAgBA;EACE,qCAAA;AAbF;;AAgBA;EACE,gCAAA;AAbF;;AAgBA;EACE,iCAAA;AAbF;;AAgBA;EACE,yCAAA;AAbF;;AAgBA;EACE,0BAAA;AAbF;;AAgBA;EACE,uBAAA;AAbF;;AAgBA;EACE,gCAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,qBAAA;EACA,cAAA;AAbF;;AAgBA;EACE,0BAAA;AAbF;;AAgBA;EACE,YAAA;AAbF;;AAgBA;EACE,WAAA;AAbF;;AAiBA;EACE,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAdF;;AAiBA;EACE,yBC5Vc;ED6Vd,mBAAA;EACA,eAAA;AAdF;;AAkBE;EACE,mDAAA;AAfJ","sourcesContent":["@import \"./variables\";\n\n//fontfamilies\n\n.font-family-roboto {\n  font-family: $font-family-roboto !important;\n}\n\n.font-family-montserrat {\n  font-family: $font-family-montserrat !important;\n}\n\n//font-sizes\n\n.primary-heading {\n  font-size: $primary-heading !important;\n}\n\n.secondary-heading {\n  font-size: $secondary-heading !important;\n}\n\n.tertiary-heading {\n  font-size: $tertiary-heading !important;\n}\n\n.super-heading {\n  font-size: $heading-48 !important;\n}\n\n.super-heading-42 {\n  font-size: $heading-42 !important;\n}\n\n.sub-heading {\n  font-size: $heading-18 !important;\n}\n\n.heading-22 {\n  font-size: $heading-22 !important;\n}\n\n\n.primary-title {\n  font-size: $primary-title !important;\n}\n\n.secondary-title {\n  font-size: $secondary-title !important;\n}\n\n.tertiary-title {\n  font-size: $tertiary-title !important;\n}\n\n.title-10 {\n  font-size: $title-10 !important;\n}\n\n//font-weights\n\n.font-weight-400 {\n  font-weight: $font-weight-400 !important;\n}\n\n.font-weight-500 {\n  font-weight: $font-weight-500 !important;\n}\n\n.font-weight-600 {\n  font-weight: $font-weight-600 !important;\n}\n\n.font-weight-700 {\n  font-weight: $font-weight-700 !important;\n}\n\n.font-weight-900 {\n  font-weight: $font-weight-900 !important;\n}\n\n//colors\n.mid-gray {\n  color: $mid-gray;\n}\n\n.primary-color {\n  color: $primary-color !important;\n}\n\n.bg-primary-color {\n  background-color: $primary-color !important;\n}\n\n.bg-solitude-color {\n  background-color: $solitude-color !important;\n}\n\n.secondary-color {\n  color: $secondary-color !important;\n}\n\n.bg-white-color {\n  background-color: $white-color !important;\n}\n\n.bg-black {\n  background-color: $black-color !important;\n}\n\n.white-color {\n  color: $white-color !important;\n}\n\n.black-color {\n  color: $black-color !important;\n}\n\n.error-color {\n  color: $error-color !important;\n}\n\n.success-color {\n  color: $success-color !important;\n}\n\n.grey-color {\n  color: $grey-color !important;\n}\n\n.selected-field-color {\n  color: $selected-field-color;\n}\n\n.dark-gray-color {\n  color: $dark-gray-color !important;\n}\n\n.orange-yellowish-color {\n  color: $orange-yellowish-color !important;\n}\n\n.orange-color-300 {\n  color: $orange-color-300 !important;\n}\n\n//bg-colors\n\n.orange-yellowish-bg-color {\n  background-color: $orange-yellowish-color !important;\n}\n\n.primary-bg-color {\n  background-color: $primary-color !important;\n}\n\n.secondary-bg-color {\n  background-color: $secondary-color !important;\n}\n\n.orange-color-bg-300 {\n  background-color: $orange-color-300 !important;\n}\n\n.bg-none {\n  background-color: transparent;\n}\n\n.green-bg-color {\n  background-color: $green-color !important;\n}\n\n.light-gray-bg-color {\n  background-color: $light-gray-color !important;\n}\n\n.bg-card-white {\n  background-color: $white-color !important;\n  border-radius: $border-radius-10 !important;\n  box-shadow: -2px 4px 15px rgba(131, 164, 249, 0.25) !important;\n}\n\n.box-shadow-global {\n  box-shadow: -2px 4px 15px rgba(131, 164, 249, 0.25) !important;\n\n}\n\n.border-radius-20-left {\n  border-radius: $border-radius-20 0px 0px $border-radius-20 !important;\n}\n\n.border-radius-20-right {\n  border-radius: 0px $border-radius-20 $border-radius-20 0px !important;\n}\n\n.border-radius-50-left {\n  border-radius: 50px 0px 0px 50px !important;\n}\n\n.border-radius-50-right {\n  border-radius: 0px 50px 50px 0px !important;\n}\n\n\n.border-radius-20-top {\n  border-radius:$border-radius-20 $border-radius-20 0px 0px !important;\n}\n\n.border-radius-10 {\n  border-radius: $border-radius-10 !important;\n}\n\n.border-radius-5 {\n  border-radius: $border-radius-5 !important;\n}\n\n.border-radius-15 {\n  border-radius: $border-radius-15 !important;\n}\n\n.border-radius-20 {\n  border-radius: $border-radius-20 !important;\n}\n\n.border-radius-rounded {\n  border-radius: $border-radius-rounded;\n}\n\n.border-dashed {\n  border: 1px dashed $icon-color !important;\n}\n\n.border-black {\n  border: 1px solid $black-color !important;\n}\n\n.border-gray {\n  border: 1px solid $icon-color !important;\n}\n\n.border-primary-active {\n  border: 1px solid $primary-color !important;\n}\n\n.border-dashed-white {\n  border: 1px dashed #fff !important;\n}\n\n.border-none {\n  border: none !important;\n}\n\n.border-error {\n  border: 1px solid #d32f2f !important;\n}\n\n.border-success {\n  border: 1px solid $success-color !important;\n}\n\n.border-warning {\n  border: 1px solid $orange-yellowish-color !important;\n}\n\n//width\n\n.guest-rating-box-shadow {\n  box-shadow: 1px 1px 8px 0px #ecf2fe;\n}\n\n.center-text {\n  text-align: center !important;\n}\n\n.flex {\n  display: flex !important;\n}\n\n.justify-center {\n  justify-content: center !important;\n}\n\n.justify-space-between {\n  justify-content: space-between !important;\n}\n\n.justify-space-around {\n  justify-content: space-around !important;\n}\n\n.justify-end {\n  justify-content: flex-end !important;\n}\n\n.align-center {\n  align-items: center !important;\n}\n\n.align-space-between {\n  align-items: space-between !important;\n}\n\n.align-end {\n  align-items: flex-end !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-grow {\n  flex-grow: 1 !important;\n}\n\n.text-decoration {\n  text-decoration: none !important;\n  color: unset !important;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.text-transform {\n  text-transform: capitalize;\n}\n\n.height-40 {\n  height: 40px;\n}\n\n.width-40 {\n  width: 40px;\n}\n\n// scroll bar style\n::-webkit-scrollbar {\n  width: 3px;\n  background-color: #F5F5F5;\n  border-radius: 10px;\n  height:4px;\n  cursor: pointer;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: $primary-color;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.hover{\n  &:hover{\n    background-color:rgba(255, 97, 29, 0.2) !important;\n  }\n}","// all color, text-sizes, border-radius etc  should be initialize here as variables and use them in styling\n// do not write explicitly values.\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n//colors\n$primary-color: #ff611d;\n$secondary-color: #333333;\n\n$black-color: #000000;\n$white-color: #ffffff;\n$dark-gray-color: #3c3c3c;\n$grey-color: #747070;\n$orange-color: #ff8908;\n$yellow-color: #ffb80e;\n$link-color: #59a9ff;\n$orange-yellowish-color: #ffa412;\n$mid-green-color: #00d27a;\n$apple-green-color:#659c35;\n$dark-white-smoke-color: #f5f8fe;\n$mix-grey-color: linear-gradient(180deg, #464c52 0%, #464c5299 100%);\n$orange-color-300: #FFA300;\n\n$solitude-color:#E9EFFD;\n$error-color: #dc3545;\n$alert-text-color:#81222C;\n$success-color: #165c27;\n$alertgreen-color: #d0e7d6;\n$alertred-color:#F7D5D8;\n$selected-tap-color: #1c1b1b;\n$rate-star-color: #ffce31;\n$icon-color: #c4c4c4;\n$selected-field-color: #6c757d;\n$hover-color: #fee6dd;\n$blue_magenta_color: #EBEBEE;\n$green-color:#40d698;\n$light-gray-color:#9d99b9;\n$mid-gray: #676c70;\n\n//font-size\n$primary-heading: 32px;\n$secondary-heading: 24px;\n$tertiary-heading: 28px;\n$heading-48: 48px;\n$heading-42: 42px;\n$heading-20: 20px;\n$heading-22: 22px;\n$heading-18: 18px;\n\n$primary-title: 16px;\n$secondary-title: 14px;\n$tertiary-title: 12px;\n$title-15: 15px;\n$title-13: 13px;\n$title-10: 10px;\n\n//border-radius\n$border-radius-4: 4px;\n$border-radius-5: 5px;\n$border-radius-10: 10px;\n$border-radius-15: 15px;\n$border-radius-20: 20px;\n$border-radius-rounded:50%;\n\n//font-weight\n$font-weight-300: 300;\n$font-weight-400: 400;\n$font-weight-500: 500;\n$font-weight-600: 600;\n$font-weight-700: 700;\n$font-weight-800: 800;\n$font-weight-900: 900;\n\n//font-family\n$font-family-montserrat: \"Montserrat\", \"Roboto\", \"sans-serif\";\n$font-family-roboto: \"Roboto\", \"sans-serif\", \"Montserrat\";"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
